import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const Callback3dsVisa = () => {
  const location = useLocation();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    const stepupresponse = searchParams.get("stepupresponse");
    const stepupauthcode = searchParams.get("stepupauthcode");

    console.log(stepupresponse);

    const deepLinkParams = new URLSearchParams();
    if (stepupresponse) {
      deepLinkParams.set("stepupresponse", stepupresponse);
    }
    if (stepupauthcode) {
      deepLinkParams.set("stepupauthcode", stepupauthcode);
    }

    const deepLink = `${"managemii://3dsActivationResult"}?${deepLinkParams.toString()}`;
    console.log(deepLink);

    setIsRedirecting(true);

    const timer = setTimeout(() => {
      window.location.replace(deepLink);
    }, 2000);

    return () => clearTimeout(timer);
  }, [location.search]);

  return (
    <div style={styles.container}>
      {isRedirecting && (
        <div style={styles.content}>
          <div style={styles.spinnerWrapper}>
            <div style={styles.spinner} />
          </div>
          <p style={styles.text}>Redirecting you back to the app…</p>
          <style>{`
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundColor: "#f9f9fb",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
  },
  spinnerWrapper: {
    width: "48px",
    height: "48px",
  },
  spinner: {
    width: "100%",
    height: "100%",
    border: "4px solid #e0e0e0",
    borderTopColor: "#1a56db",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
  text: {
    fontSize: "15px",
    color: "#6b7280",
    margin: 0,
    fontFamily: "system-ui, sans-serif",
  },
};

export default Callback3dsVisa;